import React from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';

// Helpers
import { getURLSegment, promptUser, toggleDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';
import Report from './Report';
import Drawer from '../Drawer/Drawer';
import { Validate } from '../../config.js';

const Reports = observer(class Reports extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.exportReport = this.exportReport.bind(this);
    this.completeExport = this.completeExport.bind(this);

    this.state = {
      drawerContent: null,
      drawerOpen: false,
      sessionSid: null,
    }
  }



  componentDidMount() {
    const { ReportStore } = this.props.store;

    ReportStore.reportFilters = {};



    if(getURLSegment(this, 2)) {
      ReportStore.getReportData(getURLSegment(this, 2));
    } else {
      ReportStore.reportData = [];
    }
  }

  exportReport() {
    const { translation } = this.props;
    const { ReportStore } = this.props.store;

    // Set the default export title
    ReportStore.reportExportTitle = translation.reports[getURLSegment(this, 2)].title;

    // Show a dialog to let the user change the title
    const msg = {
      heading: translation.csv_prompt.heading,
      input: translation.csv_prompt.input,
      button: translation.csv_prompt.button
    }

    promptUser(msg, this.completeExport, null, ReportStore.reportExportTitle);
  }

  completeExport() {
    const { translation } = this.props;
    const { ReportStore, SessionStore } = this.props.store;

    const callback = () => SessionStore.showToaster(translation.exported, 'success');

    ReportStore.exportData(callback);
  }

  reportList() {
    const { proctorAccountSid } = this.props.store.SessionStore.userData;
    const reports = [
      {
        url: 'exams',
        icon: <icons.iconFiles />,
        iamAction: 'sp:DescribeExamList',
        iamResource: `ssrn:ss:sp::${proctorAccountSid}:report`
      }, {
        url: 'sessions',
        icon: <icons.iconClock />,
        iamAction: 'sp:DescribeExamSessions',
        iamResource: `ssrn:ss:sp::${proctorAccountSid}:session`
      },{
        url:'appointment-timeline',
        icon: <icons.iconCalendar/>,
        iamAction: 'sp:DescribeAppointmentTimeline',
        iamResource: `ssrn:ss:sp::${proctorAccountSid}:timeline`
      },
      {
        url:'exam-accommodations',
        icon: <icons.iconCalendar/>,
        iamAction: 'sp:DescribeAppointmentTimeline',
        iamResource: `ssrn:ss:sp::${proctorAccountSid}:timeline`
      }
    ]

    return reports;
  }

  render() {
    const { translation } = this.props;
    const { ReportStore } = this.props.store;
    const { reportData } = ReportStore;
    const reportList = this.reportList();

    return(
      <main tabIndex="0" id="main-content" className="page">
        <div className="wrap">
          <header className="page__header">
            <div className="wrap">
              <h1 className="page__title">
                {translation.heading}

                {getURLSegment(this, 2) &&
                  `: ${translation.reports[getURLSegment(this, 2)].title}`
                }

                {getURLSegment(this, 2) &&
                  <Link className="page__back" to="/reports">
                    Back to all reports
                  </Link>
                }
              </h1>

              <div className="page__actions actions">
                {/* Hide the download button if there are no results */}
                {reportData && reportData.length > 0 &&
                  <button
                    className="btn--outline"
                    onClick={this.exportReport}
                  >
                    <icons.iconDownload />
                    {translation.csv_button}
                  </button>
                }

                {/* Filter button */}
                {getURLSegment(this, 2) &&
                  <button
                    className="btn"
                    onClick={() => toggleDrawer(null, this, 'ReportFilter')}
                  >
                    <icons.iconSettings />
                    {translation.filter_button}
                  </button>
                }

                {/* Exported CSVs button */}
                {!getURLSegment(this, 2) &&
                  <Link
                    className="btn--outline"
                    to="/reports/downloads"
                  >
                    {translation.exported_csvs}
                  </Link>
                }
              </div>
            </div>
          </header>

          {!getURLSegment(this, 2) &&
            <Validate>
              <ul className="block-list block-list--grid">
                {reportList.map(
                  (report, i) =>
                      <li key={i} iamAction={report.iamAction} iamResource={report.iamResource}>
                        <Link
                          className="block-list__block block-list__link"
                          to={`${getURLSegment(this, 1)}/${report.url}`}
                          onClick={() => {
                            //TODO: Remove force refresh and fix this routing, we shouldn't be depending on refreshes, this is just a quick fix to get this out
                            if(report.url !== 'appointment-timeline') {
                              ReportStore.data = [];
                              ReportStore.getReportData(report.url);
                            }
                          }}
                        >
                          {report.icon}

                          <strong className="block-list__title">
                            {translation.reports[report.url].title}
                          </strong>

                          <div className="block__copy">
                            <p>{translation.reports[report.url].description}</p>
                          </div>
                        </Link>
                      </li>
                )}
              </ul>
            </Validate>
          }

          {getURLSegment(this, 2) &&
            <Report
              reportData={ReportStore.reportData}
              parent={this}
              {...this.props}
            />
          }
        </div>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this}
          sessionSid={this.state.sessionSid}
          {...this.props}
        />
      </main>
    )
  }
})

export default translate('Reports')(Reports);



// WEBPACK FOOTER //
// ./src/app/components/Reports/Reports.js